// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__DoZW-","inputWrap":"CustomTip_inputWrap__1t2LF"};